<ng-container *ngIf="overlay;else progressSpinner">
    <div class="overlay">
        <div class="center">
            <div>aguarde....</div>
            <ng-template [ngTemplateOutlet]="progressSpinner"></ng-template>
        </div>
    </div>
</ng-container>
<ng-template #progressSpinner>
    <mat-progress-spinner [class]="classColor" [diameter]="100" [mode]="'indeterminate'" [value]="50">
    </mat-progress-spinner>
</ng-template>